/*
 *
 * ProductTour actions
 *
 */

import {
  DEFAULT_ACTION,
  UPDATE_DAY_ZERO_STATUS,
  TRIGGER_DAY_ZERO_SHOPIFY_MODAL,
  SHOW_PROFILE_ACTIVATION_SCREEN,
  UPDATE_USER_ON_PRODUCT_FRUIT,
  GET_WHITELISTING_DATA,
  GET_PAYMENT_GROUPS_DATA,
  ENABLE_LOADER,
  DISABLE_LOADER,
  GET_MERCHANT_PROFILE_DATA,
  GET_INSTALLED_APPS_DATA,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export const enableLoaderAction = () => {
  return {
    type: ENABLE_LOADER,
  };
};

export const disableLoaderAction = () => {
  return {
    type: DISABLE_LOADER,
  };
};

export const updateShopifyModal = payload => ({
  type: UPDATE_DAY_ZERO_STATUS,
  payload,
});

export const triggerShopifyModal = payload => ({
  type: TRIGGER_DAY_ZERO_SHOPIFY_MODAL,
  payload,
});

export const setProfileActivationScreen = payload => ({
  type: SHOW_PROFILE_ACTIVATION_SCREEN,
  payload,
});

export function updateUserOnProductFruit(data) {
  return {
    type: UPDATE_USER_ON_PRODUCT_FRUIT,
    payload: data,
  };
}

export const getWhiteListingSummaryData = data => {
  return {
    type: GET_WHITELISTING_DATA,
    data,
  };
};

export const getPaymentGroupsData = data => {
  return {
    type: GET_PAYMENT_GROUPS_DATA,
    data,
  };
};

export const getMerchantProfileData = data => {
  return {
    type: GET_MERCHANT_PROFILE_DATA,
    data,
  };
};

export const getInstalledAppsData = data => {
  return {
    type: GET_INSTALLED_APPS_DATA,
    data,
  };
};
